<div
  #chartContainer
  echarts
  [options]="options"
  (chartInit)="onChartInit($event)"
  (chartClick)="onChartClick($event)"
  class="w-full h-full"
></div>
